export default `
.filepond--root {
  margin-bottom: 0!important;
}
`;
